import { createContext } from "react"

interface AuthContextState {
  /**
   * The custom JWT issued by our backend API (exchanged using the B2C token).
   * - This is the token used for all form-related API requests.
   */
  token: string | undefined
  /**
   * Set or clear the value of the backend / API token */
  setToken: React.Dispatch<React.SetStateAction<string | undefined>>
  /**
   * The ID Token received from Azure B2C upon user authentication.
   * - This proves the user's identity and is used to exchange for the backend token.
   */
  adb2cToken: string | undefined
  /**
   * Set or clear the Azure B2C token (user authentication token)  */
  setAdb2cToken: React.Dispatch<React.SetStateAction<string | undefined>>
  /**
   * Clear both tokens and reset internal authentication state */
  unsetTokens(): void
}

const initialValue: AuthContextState = {
  token: undefined,
  setToken: () => {},
  adb2cToken: undefined,
  setAdb2cToken: () => {},
  unsetTokens: () => {},
}

export const AuthContext = createContext(initialValue)
